import { connect } from "react-redux";
import { useState } from "react";
import { mapStateToProps } from "../../store/helpers/mapState";
import { mapDispatchToProps } from "../../store/helpers/mapDispatch";
import React, { useEffect } from "react";
import DatatableComponent from "../../helpers/DatatableComponent";
import FormDialog from "../../helpers/FormDialog";
import moment from "moment";
import DeleteDialog from "../../helpers/DeleteDialog";
import { useHistory } from "react-router";
import StatusLayout from "components/Status";
import { IconButton } from "@mui/material";
import { de } from "date-fns/locale";
import BasicMenu from "helpers/menu";

function ProgramAssignedManagement({ location, SetSelectedMenu, FetchDetails }) {
  const [value, setValue] = useState({});
  const [list, setList] = useState([]);
  const [id, setId] = useState();
  const [departments, setDepartments] = useState([]);

  const [count, setCount] = useState(0);

  const history = useHistory();

  useEffect(() => {
    SetSelectedMenu({
      menu: "program",
      title: "Program Assign Management",
    });
  }, []);



  const columns = [
    {
      name: "id",
      label: "Name",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => {
            const program = list.find((x) => x.id === value);
         return (<span className="text-custom-blue text-xs ">{program?.program?.name}</span>)
        },
      },
    },
    {
      name: "startDate",
      label: "Start Date",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (
          <span className="text-[#A1A1A1] text-xs">
            {moment(value).format("DD/MM/yyyy") ?? ""}
          </span>
        ),
      },
    },
    {
      name: "endDate",
      label: "End Date",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (
          <span className="text-[#A1A1A1] text-xs">
            {moment(value).format("DD/MM/yyyy") ?? ""}
          </span>
        ),
      },
    },
    {
      name: "id",
      label: "Impact",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) =>{ 
            const program = list.find((x) => x.id === value);
            const impact = program?.program?.impact;

          return  (
          <span
            style={{
              color:
                value === "high"
                  ? "#FFA710"
                  : value === "medium"
                  ? "orange"
                  : "#E41010",
              fontSize: "13.92px",
            }}
            className={"text-custom-blue text-xs "}
          >
            {impact}
          </span>
        )},
      },
    },
    {
      name: "projectCount",
      label: "Projects",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (
          <span className="text-custom-blue text-xs ">{value}</span>
        ),
      },
    },
    {
      name: "completionPercentage",
      label: "Perfomance",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (
          <span className="text-custom-blue text-xs ">{
            `${parseFloat(value).toFixed(2)}%`
          }</span>
        ),
      },
    },
    {
      name: "id",
      label: "Status",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (id) => {
            const program = list.find((x) => x.id === id);
            const status = program?.program?.status;
          return (
            <span style={{ fontSize: "0.85rem" }}>
              <StatusLayout status={status == 'to-verify' ? 'under-review' : status} />
            </span>
          );
        },
      },
    },
     {
                name: "id",
                label: "Action",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRender: (v) =>  <BasicMenu onDetails={() =>  history.push(`/admin/projects/${list.find((x) => x.id === v)?.program?.id}`, { program: {
                        ...list.find((x) => x.id === v),
                        ...list.find((x) => x.id === v)?.program,
                    } }) }                  
                     />
                },
            }
  ];
  const setValue0 = (name, val) => {
    if (!name) {
      return null;
    }

    setValue((v) => {
      v[name] = val;
      return { ...v };
    });
  };
  return (
    <div className="w-full mb-12 px-4">
      <DatatableComponent
        order={location.state?.order}
        processData={(data) => {
          setList(data.data);
          return data;
        }}
        onRowSelectionChange={(list) => {


        }
        }
        onRowClick={(rowData, { rowIndex }) => {
          const program = {
            ...list[rowIndex],
            ...list[rowIndex]?.program,
          };
          history.push(`/admin/projects/${program?.id}`, { program: program });
        }
        }
        
        elevation={1}
        pdf={false}
        excel={false}
        columns={columns}
        viewColumns={false}
        searchfield={true}
        search={false}
        url={`/api/program/my-programs?count=${count}&status=${
          location.state?.status || ""
        }`} // Include the status filter in the URL
        title={"Assigned Programs"}
      />
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ProgramAssignedManagement);
